import { useLocation } from "react-router";

import { useTutorialStore } from "@/stores/useTutorialStore";

import { ROUTES } from "../../../shared";
import useNewCompanyCardActions from "./TooltipButtonActions/NewCompanyCard/useNewCompanyCardActions";
import useApplyScheduleActions from "./TooltipButtonActions/useApplyScheduleActions";
import useCompanySelectorActions from "./TooltipButtonActions/useCompanySelectorActions";
import useCreateScheduleActions from "./TooltipButtonActions/useCreateScheduleActions";
import useHandleTutorialCompletion from "./useTutorialCompletion";

const useTutorialTooltip = () => {
  const location = useLocation();

  const setIsTutorialCompanySelectorClose = useTutorialStore(
    state => state.setCompanySelectorTutorialStatus
  );

  const isCompaniesPage = location.pathname === ROUTES.Companies;
  const isVehiclesPage = location.pathname === ROUTES.Vehicles;

  const { handleTutorialCompletion } = useHandleTutorialCompletion(
    setIsTutorialCompanySelectorClose
  );

  const { companySelectorTutorialTooltipButtonActions } =
    useCompanySelectorActions(
      handleTutorialCompletion,
      setIsTutorialCompanySelectorClose
    );

  const {
    newCompanyCardDesktopButtonActions,
    newCompanyCardMobileButtonActions
  } = useNewCompanyCardActions(isCompaniesPage, handleTutorialCompletion);

  const {
    applyScheduleDesktopButtonActions,
    applyScheduleMobileButtonActions
  } = useApplyScheduleActions(isVehiclesPage, handleTutorialCompletion);

  const {
    createScheduleDesktopButtonActions,
    createScheduleMobileButtonActions
  } = useCreateScheduleActions(isVehiclesPage, handleTutorialCompletion);

  return {
    applyScheduleDesktopButtonActions,
    applyScheduleMobileButtonActions,
    companySelectorTutorialTooltipButtonActions,
    createScheduleDesktopButtonActions,
    createScheduleMobileButtonActions,
    newCompanyCardDesktopButtonActions,
    newCompanyCardMobileButtonActions
  };
};

export default useTutorialTooltip;
